import React from "react";

// Shimmer block at a height the caller chooses. (The dashboard page does not use it: it renders nothing until the data
// arrives, so a panel is never taller than its content.)
export const Skeleton = ({ height }) => (
  <section className="ff-panel" style={{ height }} aria-hidden="true">
    <div className="ff-skeleton" style={{ width: "100%", height: "100%" }} />
  </section>
);
